import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_CF_FTP_INFO,
  CfFtpInfo,
} from './cfFtpInfo.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getCfFtpInfoList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<CfFtpInfo>> {
  return http.get(`${API_PATH_CF_FTP_INFO}/${deliveryFunctionId}`);
}

export function getCfFtpInfo(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<CfFtpInfo>> {
  return http.get(`${API_PATH_CF_FTP_INFO}/${deliveryFunctionId}/${id}`);
}

export function createCfFtpInfo(
  deliveryFunctionId: string,
  body: WithAuditDetails<CfFtpInfo>,
): AxiosPromise<ServerResponse<CfFtpInfo>> {
  return http.post(`${API_PATH_CF_FTP_INFO}/${deliveryFunctionId}`, body);
}

export function updateCfFtpInfo(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<CfFtpInfo>,
): AxiosPromise<ServerResponse<CfFtpInfo>> {
  return http.put(`${API_PATH_CF_FTP_INFO}/${deliveryFunctionId}/${id}`, body);
}

export function deleteCfFtpInfo(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<CfFtpInfo>> {
  return http.delete(`${API_PATH_CF_FTP_INFO}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
